export class Parse {

    static bool(source): boolean {
        return source === true || source == "1" || source === "true";
    }

    static boolOrDefault(source, defaultValue): boolean {
        if (typeof (source) !== "undefined" && source != null)
            return source === true || source == "1" || source === "true";
        return defaultValue;
    }

    static int(source): number {
        const parsed = parseInt(source, 10);
        if (isNaN(parsed)) throw `${source} is not a number`;
        return parsed;
    }

    static intOrDefault(source, defaultValue?): number {
        const parsed = parseInt(source, 10);
        return isNaN(parsed) ? defaultValue || 0 : parsed;
    }

    static arrayOrDefault(array) {
        if (!array) return [];
        if (Array.isArray(array)) return array;
        if (Array.isArray(array.item)) return array.item;
        if (Array.isArray(array.datum)) return array.datum;
        return [array];
    };

    static fromRadix64(val: string) {
        if (val == null || !val.length) return val;
        // URL Safe Radix64 to standard Base64
        var unclean = val
            .replace(/_/g, '/')
            .replace(/-/g, '+');

        // Base64 => Hex string
        var hex = atob(unclean)
            .split('')
            .map(function(x) {
                return x.charCodeAt(0).toString(16).padStart(2, '0');
            })
            .join('');

        // Handle GUID and numeric types
        return hex.length === 32
            ? hex.substring(0, 8) + '-' + hex.substring(8, 12) + '-' + hex.substring(12, 16) + '-' + hex.substring(16, 20) + '-' + hex.substring(20) // GUID
            : parseInt(hex, 16); // Decimal
    }
}

